export default "__VITE_ASSET__WKt_DOaO__"